const Currency = {

    // FIELDS
    "name": "Name",
    "short_name": "Short Name",
    "symbol": "Symbol",
    "status": "Status",
    "country": "Country",
    "search": "Search",

    // PAGE HEADER
    "currency": "Currency",

    // ERROR
    "error_name": "Enter Name",
    "error_short_name": "Enter Short Name",
    "error_symbol": "Select Symbol",
    "error_status": "Select Status",
    "error_country": "Select Country",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_short_name": 'SHORT NAME',
    "table_symbol": 'SYMBOL',
    "table_country": "COUNTRY",
    "table_status": "STATUS",

}

export default Currency;